import { useEffect, useRef, useState } from 'react';
import DatadogService from '@shared/services/datadog';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import updateLocale from 'dayjs/plugin/updateLocale'
import i18n from '@src/i18n';

import en from 'dayjs/locale/en';
import de from 'dayjs/locale/de';
import fr from 'dayjs/locale/fr';
import pl from 'dayjs/locale/pl';
import ro from 'dayjs/locale/ro';
import bg from 'dayjs/locale/bg';
import it from 'dayjs/locale/it';
import nl from 'dayjs/locale/nl';
import pt from 'dayjs/locale/pt';
import sk from 'dayjs/locale/sk';
import tr from 'dayjs/locale/tr';
import { useTranslation } from 'react-i18next';

dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
dayjs.extend(updateLocale);

const useBackIn = () => {
  const { t } = useTranslation();
  const [eta, setEta] = useState('');
  const localeManifest = [en.name, de.name, fr.name, pl.name, ro.name, bg.name, it.name, nl.name, pt.name, sk.name, tr.name];
  const ETAHasPassedEventSentToDatadog = useRef<Boolean>(false)

  useEffect(() => {
    dayjs.locale(localeManifest.includes(i18n.language) ? i18n.language : en);
  }, [i18n.language]);

  const getDistanceDuration = (date: any) => {
    const now = dayjs().toJSON();
    if (dayjs(date?.eta).isBefore(now)) {
      if (!ETAHasPassedEventSentToDatadog.current) {
        DatadogService.createError('ETA_HAS_PASSED', { type: 'ETA Calculation', message: `ETA has passed but courier still on the way.` });
        ETAHasPassedEventSentToDatadog.current = true
      }
      return t('courier.returningToRestaurant')
    }
    const date1 = dayjs().to(dayjs(date?.eta));

    return `${t('courier.backBy')} ${date1}`
  };

  const getTimestamp = (date: any) => {
    return dayjs(date).valueOf();
  }

  const getMinutesFromThat = (date1: any, date2: any) => {
    return dayjs(date1).from(dayjs(date2), true);
  };

  return { getDistanceDuration, eta, setEta, getTimestamp, getMinutesFromThat };
};

export default useBackIn;
